import pug from 'javascripts/core_post_webpack/sitewide_business_elements/navbar/templates/paper_search_popover_bootstrap_template.jst.pug';
window.JST = window.JST || {};
window.JST[
  'core_post_webpack/sitewide_business_elements/navbar/templates/paper_search_popover_bootstrap_template'
] = pug;
